import InscreenObserver from '@finn-no/inscreen-observer';

export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const inscreenObserver = new InscreenObserver(trackElementInScreen, {
            once: true,
            threshold: element.getAttribute('data-track-threshold') || 0,
        });
        inscreenObserver.observe(element);

        function trackElementInScreen() {
            if (element.hasAttribute('data-ec-track')) {
                trackingService.trackEventObject({
                    ecType: 'AD',
                    ecCategory: 'elementInScreen',
                    eventData: {
                        element: element.getAttribute('data-ec-track'),
                        'extra.element': element.getAttribute('data-ec-track'),
                    },
                });
            }
            if (element.hasAttribute('data-adobe-track')) {
                trackingService.trackEventObject({
                    analyticsName: element.getAttribute('data-adobe-track'),
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/elementInViewTracking.js